import React from "react";
import { Empty } from "antd";
import classnames from "classnames";
import { isEmpty, map, size, trim } from "lodash";
import { EMPTY } from "constants/common";
import { AiccLessonReviewScript, AiccReviewScript } from "types/model/aiccLearningAssets";
import styles from "./LessonReviewScript.module.scss";

const LEARNER_SPEAKER = "learner";

export const getLessonScriptTitle = ({ level, lesson, scripts }: AiccLessonReviewScript) =>
  `Level ${level} Lesson ${lesson} - ${size(scripts)} variants`;

function ScriptCard({ script }: { script: AiccReviewScript }) {
  const { scriptIndex, title, sceneSetup, lines } = script;

  return (
    <div className={styles.script}>
      <div className={styles.scriptHeader}>
        <span className={styles.scriptIndex}>{`#${scriptIndex}`}</span>
        <span className={styles.scriptTitle}>{title || EMPTY}</span>
      </div>
      {!!sceneSetup && <div className={styles.sceneSetup}>{sceneSetup}</div>}
      {map(lines, ({ speaker, cue, text, transliteration }, index) => (
        <div key={index} className={styles.scriptLine}>
          <span className={classnames(styles.speaker, { [styles.learnerSpeaker]: speaker === LEARNER_SPEAKER })}>
            {speaker}
          </span>
          <span className={styles.cue}>{cue || EMPTY}</span>
          <span className={styles.lineText}>
            {text || EMPTY}
            {!!trim(transliteration) && <span className={styles.transliteration}>{transliteration}</span>}
          </span>
        </div>
      ))}
    </div>
  );
}

function LessonScripts({ scripts }: { scripts?: AiccReviewScript[] }) {
  if (isEmpty(scripts)) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No script yet." />;
  }
  return (
    <>
      {map(scripts, (script) => (
        <ScriptCard key={script.scriptIndex} script={script} />
      ))}
    </>
  );
}

export default LessonScripts;
